import { createQueryKeys } from '@lukemorales/query-key-factory';
import {
  FeatureFlagHistoriesParams,
  FeatureFlagHistoriesResponse,
  FeatureFlagListResponse,
  featureFlagApi,
} from '../../../lib/api/featureFlag';

export const featureFlagQuery = createQueryKeys('featureFlag', {
  list: () => ({
    queryKey: ['list'],
    queryFn: (): Promise<FeatureFlagListResponse> => featureFlagApi.getFlags(),
  }),
  histories: (params: FeatureFlagHistoriesParams) => ({
    queryKey: [params],
    queryFn: (): Promise<FeatureFlagHistoriesResponse> => featureFlagApi.getHistories(params),
  }),
});
